<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :close-on-backdrop="false"
    :centered="false"
    :title="title"
    :size="'xl'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
    :fullScreen="false"
  >
    <div class="row d-flex">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
        <div
          v-for="detail in localPayload.detail"
          :key="detail.subsubcategorie_id"
          class="card mb-2"
        >
          <div
            class="card-header cursor-pointer"
            @click="
              activeExam =
                activeExam == detail.subsubcategorie_id
                  ? null
                  : detail.subsubcategorie_id
            "
          >
            {{ detail.subsubcategorie_name }}
            ({{ detail.result.length }} items)
          </div>

          <div
            v-show="activeExam == detail.subsubcategorie_id"
            class="card-body"
          >
            <table class="table table-bordered table-sm result-table">
              <thead>
                <tr>
                  <th width="35%">Análisis</th>
                  <th width="20%">Resultado</th>
                  <th width="15%">Unidad</th>
                  <th width="30%">Rango</th>
                </tr>
              </thead>
              <tbody
                v-for="detail in localPayload.detail"
                :key="detail.subsubcategorie_id"
              >
                <tr
                  v-for="(result, index) in detail.result"
                  :key="detail.subsubcategorie_id + '-' + index"
                >
                  <td>{{ result.analisis }}</td>
                  <td>
                    <input
                      v-model="result.resultado"
                      class="form-control form-control-sm"
                      type="text"
                      placeholder="Digite resultado"
                    />
                  </td>
                  <td>{{ result.unid }}</td>
                  <td>{{ result.rango }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <button class="btn btn-secondary btn-sm" @click="mtdClose">
        <i class="fas fa-times"></i>&nbsp;Cerrar
      </button>
      &nbsp;
      <button class="btn btn-success btn-sm" @click="mtdSave">
        <i class="fas fa-save"></i>&nbsp;Guardar
      </button>
    </template>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/CModal.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import { mapActions } from "vuex";

export default {
  name: "c-maintenance-modal-servicioEsp",
  components: { CModal, SweetAlert },
  data() {
    return {
      swal: null,
      activeExam: null,
      localPayload: {},
    };
  },
  watch: {
    payload: {
      handler(newVal) {
        if (!newVal || !newVal.detail) return;

        this.localPayload = {
          ...newVal,
          detail: newVal.detail.map((item) => ({
            ...item,
            result: item.result.map((r) => ({
              ...r,
              resultado: "",
            })),
          })),
        };
      },
      immediate: true,
      deep: true,
    },
  },
  props: {
    title: String,
    boo_modal: Boolean,
    payload: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    formValido() {
      return (
        this.item.analisis.trim() != "" &&
        this.item.unid.trim() != "" &&
        this.item.rango.trim() != "" &&
        this.item.metodo.trim() != ""
      );
    },
    cpButton() {
      return false;
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.$emit("closeModal");
    },
    mtdResetItem() {
      this.swal= null;
      this.activeExam= null;
      this.localPayload= {};
    },
    /** Guarda en BD */
    async mtdSave() {
      this.$emit('mtdSave',this.localPayload);
    },
  },
};
</script>
<style>
.result-table {
  font-size: 12px;
}

.result-table th {
  padding: 4px 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
}

.result-table td {
  padding: 3px 6px;
  vertical-align: middle;
}

.result-table .form-control {
  height: 26px;
  min-height: 26px;
  padding: 2px 6px;
  font-size: 12px;
}
</style>